import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'currencyReverse',
})
export class CurrencyReversePipe implements PipeTransform {
  transform(items: any, value: string): string {
    return items.substr(1) + ' ' + items.substr(0, 1);
  }
}
